import { useEffect } from 'react';
import { inject } from 'mobx-react';

function Logout(props) {
  useEffect(() => props.auth.logout(), [props.auth]);
  return null;
}

export default inject('auth')(Logout);
